import { useEffect, useRef } from 'react';
export const useOptionsCache = ({ options }) => {
    const cache = useRef(new Map());
    useEffect(() => {
        options.forEach((option) => {
            if (!cache.current.has(option.value))
                cache.current.set(option.value, option);
        });
    }, [options]);
    return cache;
};
